// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3yqln","info":"PatientInfo_info__1htJq"};